import { useEffect, useState, useCallback } from "react";
import { useFinanzasINMOB } from "../../Services/Inmobiliaria/Finanzas";

export const useFinanzasTodosINMOB = () => {
  const { getFinanzasUltimoPeriodo, getFinanzasPorPeriodo,getFinanzasUltimoPeriodoMontoNeto,
    getFinanzasPorPeriodoMontoNeto } = useFinanzasINMOB();
  const [finanzas, setFinanzas] = useState(null);
  const [loadingFinanzas, setLoadingFinanzas] = useState(false);
   const [finanzasTotales, setFinanzasTotales] = useState(null);
  const [loadingFinanzasTotales, setLoadingFinanzasTotales] = useState(false);
  const [finanzasMontoNeto, setFinanzasMontoNeto] = useState(null);
  const [loadingFinanzasMontoNeto, setLoadingFinanzasMontoNeto] = useState(false);
   const [finanzasTotalesMontoNeto, setFinanzasTotalesMontoNeto] = useState(null);
  const [loadingFinanzasTotalesMontoNeto, setLoadingFinanzasTotalesMontoNeto] = useState(false);

  const fetchFinanzas = useCallback(async () => {
    try {
      setLoadingFinanzas(true);

      const data = await getFinanzasUltimoPeriodo();
      setFinanzas(data);

    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFinanzas(false);
    }
  }, [getFinanzasUltimoPeriodo]);

  const fetchFinanzasTotales = useCallback(async () => {
    try {
      setLoadingFinanzasTotales(true);

      const data = await  getFinanzasPorPeriodo();
      setFinanzasTotales(data);

    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFinanzasTotales(false);
    }
  }, [ getFinanzasPorPeriodo]);

  const fetchFinanzasMontoNeto = useCallback(async () => {
    try {
      setLoadingFinanzasMontoNeto(true);

      const data = await getFinanzasUltimoPeriodoMontoNeto();
      setFinanzasMontoNeto(data);

    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFinanzasMontoNeto(false);
    }
  }, [getFinanzasUltimoPeriodoMontoNeto]);

  const fetchFinanzasTotalesMontoNeto = useCallback(async () => {
    try {
      setLoadingFinanzasTotalesMontoNeto(true);

      const data = await  getFinanzasPorPeriodoMontoNeto();
      setFinanzasTotalesMontoNeto(data);

    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFinanzasTotalesMontoNeto(false);
    }
  }, [ getFinanzasPorPeriodoMontoNeto]);

  useEffect(() => {
    fetchFinanzas();
    fetchFinanzasTotales();
    fetchFinanzasMontoNeto();
    fetchFinanzasTotalesMontoNeto();
  }, []);

  return {
    finanzas,
    loadingFinanzas,
    refetchFinanzas: fetchFinanzas,
    finanzasTotales,
    loadingFinanzasTotales,
    refechToltales:fetchFinanzasTotales,
    finanzasMontoNeto,
    loadingFinanzasMontoNeto,
    refetchFinanzasMontoNeto: fetchFinanzasMontoNeto,
    finanzasTotalesMontoNeto,
    loadingFinanzasTotalesMontoNeto,
    refechToltalesMontoNeto:fetchFinanzasTotalesMontoNeto
  };
};